<template>
  <div>
    <!-- Not implemented on Shopify. -->
  </div>
  <div
    v-if="false && data && status == 'success'"
    class="TileTurnaroundBanner"
  >
    <div class="TileTurnaroundBanner__content">
      <div class="TileTurnaroundBanner__content-col">
        <h1
          :aria-label="data.promotionTileTurnaround.title"
          class="TileTurnaroundBanner__title"
        >
          <span
            v-for="(option, index) in data.promotionTileTurnaround.title.split(' ')"
            :key="option"
            :style="`--word-index: ${index}`"
            class="TileTurnaroundBanner__title-group"
          >
            <span
              v-for="(letter, letterIndex) in option.split('')"
              :key="`${letter}-${letterIndex}`"
              :style="`--letter-index: ${letterIndex}`"
              :data-letter="letter"
              class="TileTurnaroundBanner__title-letter"
            >
              {{ letter }}
            </span>
          </span>
        </h1>
        <div class="TileTurnaroundBanner__image-container">
          <DatoCmsImage
            :data="data.promotionTileTurnaround.imageDonut.responsiveImage"
            :priority="true"
            class="TileTurnaroundBanner__image"
            sizes="(max-width: 600px) 400px"
          />
          <span class="TileTurnaroundBanner__image-shadow" />
        </div>
      </div>
      <div class="TileTurnaroundBanner__content-col">
        <RichText
          class="TileTurnaroundBanner__copy"
          :content="data.promotionTileTurnaround.copy"
        />
        <div
          :class="['TileTurnaroundBanner__form-discount', {
            'TileTurnaroundBanner__form-discount--is-discount': hasCompletedSignup && discountCode
          }]"
        >
          <PromotionForm
            class="TileTurnaroundBanner__form"
            :data="data.promotionTileTurnaround"
            @submitted="updateSignup"
          />
          <div
            v-if="hasCompletedSignup"
            class="TileTurnaroundBanner__discount-container"
          >
            <div
              :class="[
                'TileTurnaroundBanner__discount',
                {'TileTurnaroundBanner__discount--is-active' : hasCopiedCode }
              ]"
              @click="copyDiscountCode(discountCode)"
            >
              <div class="TileTurnaroundBanner__discount-inner">
                <span class="TileTurnaroundBanner__discount-text">
                  {{ discountCode }}
                </span>
                <VisionIcon
                  v-if="!hasCopiedCode"
                  icon="copy"
                  colour="white"
                  size="x-small"
                />
                <span
                  v-else
                  class="TileTurnaroundBanner__discount-label"
                >
                  Copied
                </span>
              </div>
            </div>
            <BaseCopy
              v-if="data.promotionTileTurnaround.formDiscount"
              key="message"
              size="body-sm"
              class="TileTurnaroundBanner__discount-message"
            >
              {{ data.promotionTileTurnaround.formDiscount }}
            </BaseCopy>
          </div>
        </div>
        <div
          :class="['TileTurnaroundBanner__tile-container',{
            'TileTurnaroundBanner__tile-container--is-showing': hasCompletedSignup
          }]"
        >
          <div
            v-for="(promotion, index)
              in data.promotionTileTurnaround.promotions"
            :key="promotion.id"
            :class="['TileTurnaroundBanner__promotion-tile',{
              'TileTurnaroundBanner__promotion-tile--winner': promotion.promotionId === winningPromotion
            }]"
            :style="{animationDelay: index * 200 +'ms'}"
          >
            {{ promotion.copy }}

            <VisionLink
              v-if="(promotion.promotionId === winningPromotion)
                && showWinningCta"
              :line-link="true"
              to="/shop/all"
              class="TileTurnaroundBanner__winning-link"
              theme="white"
            >
              Shop Now
            </VisionLink>
          </div>
        </div>
      </div>
    </div>
    <DatoCmsImage
      :data="data.promotionTileTurnaround.image.responsiveImage"
      :priority="true"
      class="TileTurnaroundBanner__background"
      layout="fill"
      object-fit="cover"
      object-position="50% 50%"
    />
  </div>
</template>

<script setup>
import { Image as DatoCmsImage } from 'vue-datocms'
import query from '~/gql/tileTurnaround.gql'

const { $track } = useNuxtApp()

const hasCompletedSignup = ref(false)
const discountCode = ref(null)
const winningPromotion = ref(null)
const hasCopiedCode = ref(false)
const showWinningCta = ref(false)

const { data, status } = useDatoQuery({
  query,
  immediate: true,
})

async function updateSignup(data) {
  winningPromotion.value = data.promotion
  hasCompletedSignup.value = data.success
  discountCode.value = data.discount
  // Wait for halfway on CSS animation
  setTimeout(function() {
    showWinningCta.value = true
  }, 800);

  // Callback
  if (data.callback === 'discount') {
    applyDiscountCode(data.discount)
  }
  if (data.callback === 'product') {
    if (data.promotion === 'free-capsule-case') {
      applyPromotionProduct('case-ct_capsule')
      applyDiscountCode(data.discount)
    }
  }
  
  $track.form.submitted({
    context: 'Tile Turnaround'
  })
}

function applyDiscountCode(_code) {
  // await $commerce.coupon.add(code)
}

function applyPromotionProduct(_sku) {
  // If this SKU is already in cart then we don't want to add it again
  // const lineItems = $commerce.state.cart?.discreteLineItems?.map(
  //   (lineItem) => lineItem.bundleCode
  // ) || []
  // if (lineItems.some(sku => sku?.includes(sku))) return

  // await $commerce.cart.add([{
  //   sku,
  //   quantity: 1,
  //   isLimitedEdition: false,
  //   legacySKU: sku,
  //   metadata: {
  //     isPromotionItem: true
  //   }
  // }])
}

function copyDiscountCode(code) {
  hasCopiedCode.value = true
  navigator.clipboard.writeText(code)
}

</script>

<style lang="postcss" scoped>
.TileTurnaroundBanner {
  @apply relative py-12 md:py-24
  w-[100vw] min-h-[50vh];
  margin-left: calc(0px - var(--outer-gutter));
  margin-right: calc(0px - var(--outer-gutter));

  @screen xxl {
    margin-left: calc(0px - (((100vw - var(--screen-size)) / 2) + var(--outer-gutter)));
    margin-right: calc(0px - (((100vw - var(--screen-size)) / 2) + var(--outer-gutter)));
  }
}

.TileTurnaroundBanner__content {
  @apply relative z-[2]
  flex flex-col items-center justify-center md:gap-10 md:flex-row
  text-white;
}

.TileTurnaroundBanner__content-col {
  @apply max-w-[516px] w-full;

  @screen mdMax {
    @apply px-[var(--outer-gutter)]
  }
}

.TileTurnaroundBanner__form-discount {
  @apply relative mb-10;
  .TileTurnaroundBanner__discount {
    @apply opacity-0 pointer-events-none transition-all delay-[250ms] scale-[1.1];
  }

  .TileTurnaroundBanner__form {
    @apply transition-all;
  }

  &--is-discount {
    .TileTurnaroundBanner__discount {
      @apply opacity-100 scale-100 pointer-events-auto;
    }

    .TileTurnaroundBanner__form {
      @apply opacity-0 scale-[0.9] pointer-events-none;
    }
  }
}

.TileTurnaroundBanner__discount-container {
  @apply absolute inset-0;
}

.TileTurnaroundBanner__discount {
  @apply relative top-0 left-0 right-0 p-0.5 h-14 rounded-full overflow-hidden;

  &::after {
    @apply absolute top-0 left-0 h-full w-[200%] z-0;
    content:'';
    background: linear-gradient(90deg, #0A4ED3 0%, #23B6EC 27.71%, #E3A354 45.55%, #23B6EC 60.58%, #0A4ED3 93.93%), #D9D9D9;
    animation: gradientTileTurnaround 10s ease-in-out infinite;
  }

  &-text {
    @apply heading-4
  }
}

.TileTurnaroundBanner__discount-inner {
  @apply relative z-[1] flex rounded-full items-center justify-between
  w-full h-full bg-off-black px-5 pr-3 transition-transform cursor-pointer;
}

.TileTurnaroundBanner__discount-label {
  @apply pointer-events-none
  bg-green
  px-3 py-1 rounded-full
  text-white text-xxs uppercase font-bold;
}

.TileTurnaroundBanner__discount-message {
  @apply mt-3 text-xxs;
}

.TileTurnaroundBanner__title {
  @apply block heading-1 text-6xl xsMax:text-4xl uppercase text-center leading-none
  max-w-[400px] w-full mx-auto;
  animation: textGlow 4s ease-in-out infinite;

  &-group {
    @apply inline-block relative overflow-hidden w-full;

    &:nth-child(0n + 2) {
      @apply text-right;
    }

    &:nth-child(0n + 3) {
      @apply text-left;
    }
  }


  &-letter {
    @apply relative inline-block;
    animation: textTurnaround 4s ease-in-out infinite;
    animation-delay: calc((var(--word-index) * 100ms) + (var(--letter-index) * 25ms));

    &:after {
      @apply content-[attr(data-letter)] absolute top-full left-0;
    }
  }
}

.TileTurnaroundBanner__image-container {
  @apply relative;
}

.TileTurnaroundBanner__image {
  @apply relative;
  animation: float 6s ease-in-out infinite;

  &-shadow {
    @apply block absolute bottom-0 left-0
    w-full h-10 z-[-1] rounded-full blur-[40px];
    background: linear-gradient(
      79deg, #1B3037 17.37%,
      #E3A354 21.99%,
      #23B6EC 34.96%,
      #0A4ED3 50.79%,
      #23B6EC 72.11%,
      #E3A354 86.19%,
      #1B3037 91.24%), #FFF;
    animation: pulse 6s ease-in-out infinite;
  }
}

.TileTurnaroundBanner__copy {
  @apply mb-6;
}

.TileTurnaroundBanner__tile-container {
  @apply flex flex-wrap justify-center items-center gap-x-[5%] gap-y-6;

  &--is-showing {
    .TileTurnaroundBanner__promotion-tile {
      animation: tileTurnaround 1.6s linear forwards;

      &--winner {
        animation-name: tileTurnaroundWinner;
      }
    }
  }
}

.TileTurnaroundBanner__promotion-tile {
  @apply basis-[30%] smMax:basis-[47.5%] aspect-square rounded-lg
  flex flex-col gap-y-2 justify-center items-center p-3 leading-5
  font-bold text-center
  border-[#748192] border-[1px]
  backdrop-blur bg-[rgba(0,0,0,0.16)];
}

.TileTurnaroundBanner__background {
  @apply absolute inset-0 z-0;
}

@keyframes textGlow {
  0% {
    filter: drop-shadow(0px 0px 16px rgba(255,255,255, 0.64));
  }
  50% {
    filter: drop-shadow(0px 0px 4px rgba(255,255,255, 0.32));
  }
  100% {
    filter: drop-shadow(0px 0px 16px rgba(255,255,255, 0.64));
  }
}

@keyframes float {
  0% {
    transform: translateY(0)
  }
  50% {
    transform: translateY(-8px)
  }
  100% {
    transform: translateY(0)
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    filter: blur(32px);
  }
  50% {
    transform: scale(0.9);
    filter: blur(56px);
  }
  100% {
    transform: scale(1);
    filter: blur(32px);
  }
}

@keyframes textTurnaround {
  0% {
    transform: translateY(0%)
  }
  10% {
    transform: translateY(-100%)
  }
  100% {
    transform: translateY(-100%)
  }
}

@keyframes tileTurnaround {
  0% {
    transform: rotateY(0deg) scale(1)
  }
  50% {
    transform: rotateY(90deg) scale(1);
    color: white;
    border-color: #748192;
  }
  100% {
    transform: rotateY(0deg) scale(0.8);
    color: #4C5663;
    border-color: #4C5663;
  }
}

@keyframes tileTurnaroundWinner {
  0% {
    @apply bg-[rgba(0,0,0,0.16)];
    transform: rotateY(0deg) scale(1);
    filter: drop-shadow(0px 0px 16px rgba(255,255,255, 0));
  }
  50% {
    @apply bg-[rgba(0,0,0,0.16)];
    transform: rotateY(90deg) scale(1);
    border-color: #748192;
    filter: drop-shadow(0px 0px 16px rgba(255,255,255, 0));
  }
  100% {
    @apply bg-[rgba(0,0,0,0.64)];
    transform: rotateY(0deg) scale(1.15);
    border-color: white;
    filter: drop-shadow(0px 0px 24px rgba(75, 192, 235, 0.64));
  }
}

@keyframes gradientTileTurnaround {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0)
  }
}
</style>